<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-menu"
  >
    <path
      fill-rule="evenodd"
      d="M19.875 16c.345 0 .625.28.625.625s-.28.625-.625.625H3.625c-.345 0-.625-.28-.625-.625S3.28 16 3.625 16h16.25zm0-5c.345 0 .625.28.625.625s-.28.625-.625.625H3.625c-.345 0-.625-.28-.625-.625S3.28 11 3.625 11h16.25zm0-5c.345 0 .625.28.625.625s-.28.625-.625.625H3.625C3.28 7.25 3 6.97 3 6.625S3.28 6 3.625 6h16.25z"
    />
  </svg>
</template>
